import type {
  ReportOverviewMetricTone,
  ReportOverviewMetricsProps,
} from '../types/components'
import { cn } from '@lib/utils/helpers'
import styles from '../styles/reportOverview.module.css'

const TONE_CLASS: Record<ReportOverviewMetricTone, string> = {
  blue: styles.toneBlue,
  violet: styles.toneViolet,
  green: styles.toneGreen,
  sky: styles.toneSky,
  amber: styles.toneAmber,
}

function cardsColsClass(count: number): string {
  if (count <= 1) return styles.overviewCardsCols1
  if (count === 2) return styles.overviewCardsCols2
  if (count === 3) return styles.overviewCardsCols3
  return styles.overviewCardsCols4
}

export function ReportOverviewMetrics({
  title,
  subtitle,
  items,
  loading = false,
  testIdPrefix = 'report-overview',
  className,
}: ReportOverviewMetricsProps) {
  if (items.length === 0) return null

  return (
    <div
      data-testid={`${testIdPrefix}-metrics`}
      className={cn(
        styles.overviewContainer,
        loading && 'pointer-events-none opacity-60',
        className,
      )}
    >
      <div className={styles.overviewHeader}>
        <h2 className={styles.overviewTitle}>{title}</h2>
        {subtitle ? (
          <p className={styles.overviewSubtitle}>{subtitle}</p>
        ) : null}
      </div>
      <div
        className={cn(styles.overviewCards, cardsColsClass(items.length))}
      >
        {items.map((item) => {
          const tone = item.tone ?? 'blue'
          return (
            <div
              key={item.id}
              data-testid={`${testIdPrefix}-metric-${item.id}`}
              className={cn(styles.overviewCard, TONE_CLASS[tone])}
            >
              <div className={styles.overviewCardAccent} />
              <div className={styles.overviewCardIconWrapper}>{item.icon}</div>
              <div className={styles.overviewCardContent}>
                <span className={styles.overviewCardLabel}>{item.label}</span>
                {item.secondaryValue ? (
                  <span className={styles.valueStack}>
                    <span className={styles.valuePrimary}>{item.value}</span>
                    <span className={styles.valueSecondary}>
                      {item.secondaryValue}
                    </span>
                  </span>
                ) : (
                  <span className={styles.overviewCardValue}>{item.value}</span>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
